import React, { useState } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import styled from 'styled-components';
import CheckBox from '../../components/common/CheckBox';

import { finalPass } from '../../lib/api/admin';
import { adminFieldState } from '../../lib/store/adminAtom';
import { useRecoilValue } from 'recoil';

const ListItem = ({ item, setData }) => {
  const {
    id,
    name,
    studentId,
    department,
    position,
    interview,
    firstRoundStatus,
    finalRoundStatus,
  } = item;
  const navigate = useNavigate();
  const location = useLocation();

  const currentField = useRecoilValue(adminFieldState);
  const [finalResult, setFinalResult] = useState(
    finalRoundStatus === 'PASSED_FINAL',
  );

  const _handleCheck = async (event) => {
    event.stopPropagation();

    const newStatus = finalResult ? 'FAILED_FINAL' : 'PASSED_FINAL';
    setFinalResult(!finalResult);

    try {
      await finalPass(id, newStatus);
    } catch (error) {
      console.error('API 호출 실패:', error);
      setFinalResult(finalResult);
    }
  };

  return (
    <ListItemContainer
      onClick={() => navigate(location.pathname + '/' + id)}
      firstRoundStatus={firstRoundStatus}
    >
      <div>{id}</div>
      <div>{name}</div>
      <div>{studentId}</div>
      <div>
        {position === 'DEVELOPER_LEAD_FRONT'
          ? '프론트리드'
          : position === 'DEVELOPER_LEAD_BACK'
            ? '백리드'
            : position === 'DEVELOPER_INTERN_FRONT'
              ? '프론트인턴'
              : position === 'DEVELOPER_INTERN_BACK'
                ? '백인턴'
                : '디자이너'}
      </div>
      <div>{department}</div>
      <div>{interview}</div>
      <div>
        <CheckBox checked={finalResult} onToggle={_handleCheck} height={1.5} />
      </div>
    </ListItemContainer>
  );
};

export default ListItem;

export const ListItemContainer = styled.div`
  width: 100%;
  display: flex;
  background-color: ${({ firstRoundStatus }) => {
    if (!firstRoundStatus || firstRoundStatus === 'UNDEFINED')
      return 'transparent';
    if (firstRoundStatus === 'FAILED_FIRST') return '#640000';
    if (firstRoundStatus === 'PASSED_FIRST') return '#0C3A00';
    return 'transparent';
  }};
  cursor: pointer;

  & div {
    height: 3rem;
    display: flex;
    justify-content: center;
    align-items: center;
    font-size: 1rem;
    padding: 0 10px;
    text-align: center;
  }

  & div:nth-child(1) {
    width: 8%;
    font-weight: 400;
  }
  & div:nth-child(2) {
    width: 10%;
    font-weight: 600;
  }
  & div:nth-child(3) {
    width: 12%;
  }
  & div:nth-child(4) {
    width: 12%;
  }
  & div:nth-child(5) {
    width: 26%;
  }
  & div:nth-child(6) {
    width: 22%;
  }
  & div:nth-child(7) {
    width: 10%;
  }
`;
